import { useEffect } from "react";
import { usePostHog } from "@posthog/react";
import { useAppContext } from "src/shared/context/AppContext";
import { useCookiePreferences } from "src/shared/context/cookie-preferences-context";
import { sanitizeEventProperties, subscribeToAnalyticsEvents } from "src/shared/utils/posthog/posthog-event-forwarding";

export const PostHogSessionReplay = () => {
  const posthog = usePostHog();
  const appContext = useAppContext();
  const cookiePreferences = useCookiePreferences();
  const hasAnalyticsConsent = !!cookiePreferences.preferences.analytics;

  useEffect(() => {
    if (!hasAnalyticsConsent) {
      return;
    }

    // The SDK is initialised with opt_out_capturing_by_default so it stays inert for
    // users not in this experiment. Opt in now that we know we're gated and consented.
    posthog.opt_in_capturing();
    posthog.register({ environment: appContext.env["REACT_APP_NODE_ENV"] ?? "development" });
    posthog.startSessionRecording();

    const unsubscribe = subscribeToAnalyticsEvents((eventName, eventBody) => {
      posthog.capture(eventName, sanitizeEventProperties(eventBody));
    });

    return () => {
      unsubscribe();
      posthog.stopSessionRecording();
      posthog.opt_out_capturing();
    };
  }, [posthog, hasAnalyticsConsent, appContext.env]);

  return null;
};
